<template>
    <div>
        <b-form @submit="onSubmit" @reset="onReset">
            <b-col cols="12">
                <b-form-group label="Plan Name" label-cols="3">
                    <b-form-input v-model="claim.planName" required disabled />
                </b-form-group>
                <b-form-group label="Payer Id" label-cols="3">
                    <b-form-input v-model="claim.payerId" required disabled />
                </b-form-group>
                <b-form-group label="Plan Paid" label-cols="3">
                    <b-form-input v-model="claim.planPaid" type="number" step="0.01" min="0"
                                  @blur="claim.planPaid = !claim.planPaid ? claim.planPaid : Math.max(claim.planPaid, 0)" required />
                </b-form-group>
                <b-form-group label="Voucher Paid" label-cols="3">
                    <b-form-input v-model="claim.voucherPaid" type="number" step="0.01" min="0"
                                  @blur="claim.voucherPaid = !claim.voucherPaid ? claim.voucherPaid :  Math.max(claim.voucherPaid, 0)"  required />
                </b-form-group>
                <b-form-group label="Patient Pay" label-cols="3">
                    <b-form-input v-model="claim.patientPay" type="number" step="0.01" min="0"
                                  @blur="claim.patientPay = !claim.patientPay ? claim.patientPay : Math.max(claim.patientPay, 0)" required />
                </b-form-group>
                <b-form-group v-if="claim.transactionStatus === 'Rejected'" label-cols="3">
                    <template #label>
                        Reject Codes
                    </template>
                    <b-form-input v-model="claim.rejectCodes" />
                    <small class="text-muted">Comma separated list of reject codes.</small>
                </b-form-group>
                <b-form-group label="Paid?" label-cols="3">
                    <b-form-checkbox v-model="claim.transactionStatus" value="Paid" unchecked-value="Rejected" />
                    {{ claim.transactionStatus }}
                </b-form-group>
            </b-col>
            <b-row>
                <b-col class="text-left">
                    <b-button type="reset" variant="danger">Reset</b-button>
                </b-col>
                <b-col class="text-right">
                    <b-button type="submit" variant="primary">Submit</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script lang="ts">
import { Component, Vue, VModel, Watch, Prop } from "vue-property-decorator";
import { Prescription } from "@/models/Prescription";
import { Claim } from "@/models/Claim";
import { CombinedPlan } from "@/models/CombinedPlan";
import axios from "axios";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";
import HelpPopup from "@/components/HelpPopup.vue";

@Component({
    name: "ClaimFormComponent",
    components: {
        HelpPopup
    }
})
export default class ClaimFormComponent extends Vue {
    @VModel() private prescription!: Prescription;
    @Prop() private plan!: CombinedPlan;
    protected claim: Claim = { transactionStatus: "Paid" } as Claim;

    @Watch("plan", { immediate: true })
    planUpdated() {
        console.log("plan: ", this.plan);
        this.claim.planId = this.plan?.plan?.id?.toString();
        this.claim.planName = this.plan?.plan?.name;
        this.claim.payerId = this.plan?.plan?.bin;
    }

    @Watch("value")
    prescriptionUpdated(_rx: Prescription, _oldRx: Prescription) {
        // this.fetchClaims();
    }

    async onSubmit(event: Event) {
        event.preventDefault();

        try {
            let resp = await axios.post<Claim>(`/api/Insurance/${this.prescription.rxID}/ManualClaim`, this.claim);
            this.$emit('claimSaved', resp.data);
        } catch (err) {
            console.log(err);
            this.$notification(NotificationOptions.error(err));
        }
    }

    onReset(event: Event) {
        event.preventDefault();
        this.claim = { transactionStatus: "Paid" } as Claim;
        this.planUpdated();
    }

}
</script>

<style scoped></style>
